import React from "react";
import { Switch, Redirect, Route, useRouteMatch } from "react-router-dom";
import Disposition from "./Disposition/Main";
import Dialer from "../Dialer";
import ManageNumbers from "./ManageNumbers/Main";
import Utils from "Utils/utils";

const Routing = () => {
  let { path = "" } = useRouteMatch();
  const isAdmin = Utils.isAdmin();
  return (
    <Switch>
      <Route exact path={`${path}/general`} component={Dialer} />
      <Route exact path={`${path}/callDisposition`} component={Disposition} />
      {isAdmin && <Route exact path={`${path}/manageNumbers`} component={ManageNumbers} />}
      <Redirect from={path} to={`${path}/general`} />
    </Switch>
  );
};
export default Routing;
